import { observer } from "mobx-react-lite";
import FontBody3 from "../../../../../../../components/fonts/font-body3/font-body3";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import { RESOLUTION_CATEGORY } from "../../../../../../../models/ResolutionTypes";
import portalStore from "../../../../../../../stores/current-portal-store";
import { RESOLUTION_TYPE } from "../../../../../constants";
import { ResolutionLineItemProps } from "../resolution-line";

const ResolutionLineItemRange: React.FC<ResolutionLineItemProps> = observer(({ category, resolution }) => {
    // cancel order resolutions do not have ranges
    if (category === RESOLUTION_CATEGORY.cancel_order_resolutions) {
        return <></>;
    }

    // manual exchange resolutions do not have ranges
    if (resolution.resolutionType === RESOLUTION_TYPE.ManualExchangeType) {
        return <></>;
    }

    const getItemRangeTitle = () => {
        switch (category) {
            case RESOLUTION_CATEGORY.exchange_resolutions:
                return 'Variant price range';
            case RESOLUTION_CATEGORY.standard_resolutions:
                return 'Refund amount';
            case RESOLUTION_CATEGORY.returngo_resolutions:
                return 'Offer range';
        }
    }

    const getItemRangeValue = () => {
        switch (category) {
            case RESOLUTION_CATEGORY.exchange_resolutions:
                return getVariantPriceRange();
            case RESOLUTION_CATEGORY.standard_resolutions:
                return getRefundAmount();
            case RESOLUTION_CATEGORY.returngo_resolutions:
                return getOfferRange();
        }
        return '';    
    }

    const getVariantPriceRange = () => {
        if (resolution.rangeFrom !== null && resolution.rangeTo !== null) {
            return `${resolution.rangeFrom} - ${resolution.rangeTo}%`
        }

        return '';
    }

    const getRefundAmount = () => {
        if (resolution.modifyCreditAmount === null || resolution.modifyCreditAmount === undefined) {
            return '';
        }

        if (resolution.isPercentage) {
            switch (resolution.creditAmountType) {
                case 0:
                    return `${100 - resolution.modifyCreditAmount}%`;
                case 1:
                    return `${100 + resolution.modifyCreditAmount}%`;
                case 2:
                    return `${resolution.modifyCreditAmount}%`;
                default:
                    return '';
            }
        }

        const currency = portalStore.setting?.currencyCode;
        switch (resolution.creditAmountType) {
            case 0:
                return `100% - ${currency}${resolution.modifyCreditAmount}`;
            case 1:
                return `100% + ${currency}${resolution.modifyCreditAmount}`;
            case 2:
                return `${currency}${resolution.modifyCreditAmount}`;
            default:
                return '';
        }
    }

    const getOfferRange = () => {
        return resolution.rangeFrom === resolution.rangeTo ?
            `${resolution.rangeTo}%` : `${resolution.rangeFrom}-${resolution.rangeTo}%`;
    }

    return (
        <>
            <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]}>
                { getItemRangeTitle() }
            </FontBody3>
            <FontBody3 color={FONT_COLOR.PRIMARY3_50}>
                { getItemRangeValue() }
            </FontBody3>
        </>
    );
});

export default ResolutionLineItemRange;